import { configureStore, MiddlewareArray } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import thunk, { ThunkAction, ThunkMiddleware } from 'redux-thunk';
import { binderViewerApi } from 'src/components/Services/BinderViewer';
import { masterDocumentApi } from 'src/components/Services/MasterDocument';
import { recentDocumentApi } from 'src/components/Services/RecentDocument';
import { studyApi } from 'src/components/Services/Study';
import { utilsApi } from 'src/components/Services/Utils';
import { binderViewReducer } from './binderViewReducer';
import confirmExitValueReducer from './confirmExitValue';
import confirmExitPopupValReducer from './confirmPopupVal';
import { documentDetailReducer } from './documentDetail';
import { loader } from './Loader';
import MoveTabReducer from './MoveTab';
import { preferences } from './preferences';
import { rowReducer } from './rowGridData';
import { searchDetailReducer } from './searchHierarchyDetails';
import { searchReducer } from './searchReducer';
import settingsReducer from './snackbarMessage';
import { user } from './User';
import { MapIsfArtifacts } from './MapIsfArtifacts';

const rootReducer = combineReducers({
  documentDetail: documentDetailReducer,
  rowDetail: rowReducer,
  settings: settingsReducer,
  binderViewSettings: binderViewReducer,
  user: user.reducer,
  preferences: preferences.reducer,
  searchDetails: searchReducer,
  searchHierarchyDetails: searchDetailReducer,
  confirmexitvalue: confirmExitValueReducer,
  confirmexitpopupval: confirmExitPopupValReducer,
  MoveTab: MoveTabReducer,
  MapIsfArtifacts: MapIsfArtifacts.reducer,
  [recentDocumentApi.reducerPath]: recentDocumentApi.reducer,
  [binderViewerApi.reducerPath]: binderViewerApi.reducer,
  loader: loader.reducer,
  [masterDocumentApi.reducerPath]: masterDocumentApi.reducer,
  [studyApi.reducerPath]: studyApi.reducer,
  [utilsApi.reducerPath]: utilsApi.reducer
});

export { rootReducer };

type AppThunkMiddleware = ThunkMiddleware<ReturnType<typeof rootReducer>, Parameters<typeof rootReducer>[1]>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: new MiddlewareArray().concat(
    thunk as AppThunkMiddleware,
    binderViewerApi.middleware,
    masterDocumentApi.middleware,
    studyApi.middleware,
    utilsApi.middleware
  )
});

type AppAction = Parameters<typeof rootReducer>[1];

export type AppDispatch = typeof store.dispatch;

export type AppState = ReturnType<typeof store.getState>;

export type AppThunk<A extends AppAction> = ThunkAction<void, AppState, unknown, A>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

// eslint-disable-next-line react-hooks/rules-of-hooks

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;
